var React = require('react');

function Eth (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M27 58l23 14.008v18.676L27 58zm46 0L50 90.684V72.008L73 58zm-23 7.684L27 51.158h46L50 65.684zM50 10l23 41.158H27L50 10z"}));
}

Eth.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100"};

module.exports = Eth;

Eth.default = Eth;
